import {
  permissionsList,
  permissionsWithAssignedIds,
} from '../../../api/constant';

const landingPageItemIds = {
  createPatient: 1,
  createUser: 2,
  viewPatients: 3,
  viewUsers: 4,
};

export const SIDEBAR_ITEMS = [
  {
    title: 'Dashboard',
    url: '/',
    activeIdentifier: 'dashboard',
    permissionsRequired: null,
    iconClassName: 'icon-home',
  },
  {
    title: 'Patient',
    url: '/view-patients',
    activeIdentifier: 'patients',
    permissionsRequired:
      permissionsWithAssignedIds[permissionsList.ViewPatient],
    iconClassName: 'icon-users',
  },
  {
    title: 'Users',
    url: '/view-users',
    activeIdentifier: 'users',
    permissionsRequired: permissionsWithAssignedIds[permissionsList.ViewUser],
    iconClassName: 'icon-users',
  },
  {
    title: 'Clinical',
    url: '/view-fet-patients',
    activeIdentifier: 'clinical',
    permissionsRequired:
      permissionsWithAssignedIds[permissionsList.ClinicalManager],
    iconClassName: 'fa fa-info-circle',
  },
  {
    title: 'Andrology',
    url: '/andrology',
    activeIdentifier: 'andrology',
    permissionsRequired:
      permissionsWithAssignedIds[permissionsList.AndrologyManager],
    iconClassName: 'icon-users',
  },
  {
    title: 'Embryology',
    url: '/embrology',
    activeIdentifier: 'embryology',
    permissionsRequired:
      permissionsWithAssignedIds[permissionsList.EmbrologyManager],
    iconClassName: 'icon-users',
  },
  {
    title: 'Notifications',
    url: '/notifications',
    activeIdentifier: 'notifications',
    permissionsRequired:
      permissionsWithAssignedIds[permissionsList.FreezingNotifications],
    iconClassName: 'icon-users',
  },
  {
    title: 'Reports',
    url: '/',
    activeIdentifier: 'reports',
    permissionsRequired: null,
    iconClassName: 'icon-users',
  },
  {
    title: 'KPI',
    url: '/kpi',
    activeIdentifier: 'kpi',
    permissionsRequired: permissionsWithAssignedIds[permissionsList.AddRole],
    iconClassName: 'icon-users',
  },
  {
    title: 'Settings',
    url: '/',
    activeIdentifier: 'settings',
    permissionsRequired: null,
    iconClassName: 'icon-users',
  },
];
export const dashboardItems = [
  {
    title: 'Add Patient',
    icon: <i className="fa fa-user"></i>,
    link: '/patient-form',
    requiredPermission: permissionsWithAssignedIds[permissionsList.AddPatient],
    description: 'Register a new patient into the system',
  },
  {
    title: 'Add User',
    icon: <i className="fa fa-user-circle-o"></i>,
    link: '/add-user',
    requiredPermission: permissionsWithAssignedIds[permissionsList.CreateUser],
    description: 'Register a new user into the system',
  },
  {
    title: 'Clinical Management',
    icon: <i className="fa fa-info"></i>,
    link: '/view-fet-patients',
    requiredPermission:
      permissionsWithAssignedIds[permissionsList.ClinicalManager],
    description: "Manage patient's clinical records",
  },
  {
    title: 'Andrology',
    icon: <i className="fa fa-info"></i>,
    link: '/andrology',
    requiredPermission:
      permissionsWithAssignedIds[permissionsList.AndrologyManager],
    description: "Manage patient's andrology records",
  },
  {
    title: 'Embrology',
    icon: 'Icon',
    link: '/embrology',
    requiredPermission:
      permissionsWithAssignedIds[permissionsList.EmbrologyManager],
    description: "Manage patient's embrology records",
  },
  {
    title: 'Settings',
    icon: 'Icon',
    link: '#',
    requiredPermission: null,
    description: 'Item yet to be decided',
  },
];

export const userItems = [
  {
    title: 'View Users',
    icon: <i className="fa fa-user-circle-o"></i>,
    link: '/view-users',
    viewUsers: landingPageItemIds.viewUsers,
  },
  {
    title: 'Add User',
    icon: <i className="fa fa-user-circle-o"></i>,
    link: '/add-user',
    createUser: landingPageItemIds.createUser,
  },
];

export const patientItems = [
  {
    title: 'View Patients',
    icon: <i className="fa fa-user-circle-o"></i>,
    link: '/view-patients',
    createUser: landingPageItemIds.viewPatients,
  },
  {
    title: 'Add Patient',
    icon: <i className="fa fa-user-circle-o"></i>,
    link: '/patient-form',
    createUser: landingPageItemIds.createUser,
  },
];

export const clinicalManagementItems = [
  {
    title: 'Patients',
    icon: <i className="fa fa-calendar"></i>,
    link: '/view-fet-patients',
    clinicalManager: 16,
  },
  {
    title: 'View Reports',
    icon: <i className="fa fa-file-text"></i>,
    link: '/view-reports',
    viewReports: landingPageItemIds.viewReports,
  },
  {
    title: 'Manage Inventory',
    icon: <i className="fa fa-medkit"></i>,
    link: '/manage-inventory',
    manageInventory: landingPageItemIds.manageInventory,
  },
];
